import React, { Component } from "react";
import "../../styles/features/Home/News.css";
import { Row, Col, CardBody, CardTitle, Card } from "reactstrap";
import { Select } from "antd";
import LoadMore from "../../components/LoadMore";
import { AllNews, getStrukturat, AllNewsByStructureId } from "./data";
import Spinner from "../../containers/Spinner";
import img from "../../assets/images/parlament.jpg";
const Option = Select.Option;

class HomeNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingState: false,
      page: 0,
      type: "All"
    };
  }

  componentDidMount() {
    AllNews(this.state.page).then(response => {
      this.setState({ lajmet: response });
    });
    getStrukturat().then(response => {
      this.setState({ strukturat: response });
    });
  }
  loadMoreItems = () => {
    if (this.state.type === "All") {
      this.setState({ page: this.state.page + 1 }, () => {
        AllNews(this.state.page).then(response => {
          this.setState({ lajmet: response });
        });
      });
    } else {
      AllNewsByStructureId(this.state.page, this.state.type).then(response => {
        this.setState({ lajmet: response });
      });
    }
  };
  transform = data => {
    let lang = localStorage.getItem("language");
    if (lang === "en") {
      data.Titulli = data.TitulliEn;
      data.NenTitulli = data.NenTitulliEn;
      data.Permbajtja = data.PermbajtjaEn;
    }
    console.log(data, "transform");
    return data;
  };
  getByStruktura = e => {
    console.log(e);
    if (e === "All") {
      console.log("here");
      this.setState({ type: e, page: 0 });
      AllNews(0).then(response => {
        this.setState({ lajmet: response });
      });
      return;
    }
    this.setState({ page: 0, type: e }, () => {
      AllNewsByStructureId(this.state.page, e).then(response => {
        this.setState({ lajmet: response });
      });
    });
  };
  render() {
    console.log(this.state);
    if (!this.state.lajmet || !this.state.strukturat) {
      return <Spinner />;
    }
    return (
      <div className="news-full scrollbar" ref="iScroll">
        <div className="filters">
          <div className="filtro-lajmet">Filtro Lajmet sipas Struktures</div>
          <Select
            defaultValue="All"
            style={{ width: 220 }}
            onChange={e => {
              this.getByStruktura(e);
            }}
          >
            <Option value={"All"}>Te Gjitha</Option>
            {this.state.strukturat.map(str => {
              return <Option value={str.id}>{str.emri}</Option>;
            })}
          </Select>
        </div>
        <Row style={{ justifyContent: "center" }}>
          {this.state.lajmet.map((News, index) => {
            News = this.transform(News);
            console.log(News);
            var w = window.innerWidth;
            var titulli = News.Titulli;

            if (titulli && w < 411) {
              if (titulli.length > 200) {
                titulli = titulli.slice(0, 200) + " ...";
              }
            }

            console.log(titulli);
            return (
              <Col lg={9} md={10} sm={12} xs={12} className="mb-3">
                <Card
                  className="flex-row materialNews"
                  style={{ height: 150, overflow: "hidden" }}
                >
                  <div className="img-cont img-cont-index">
                    <img className="card-img-left" src={img} alt=" " />
                    {/* <div class="top-left ">{News.Struktura.Emri}</div> */}
                    <div class="bottom-right">{News.DateKrijuar}</div>
                  </div>
                  <CardBody className="index-body">
                    <CardTitle className="cardTitle index-title">
                      {titulli}
                    </CardTitle>
                    {/* <CardText>
                      <div className="cardText index-nentitulli">
                        {News.NenTitulli}
                      </div>
                    </CardText> */}
                    <div className="readMoreRight">
                      <LoadMore history={this.props.history} id={News.ID} />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Row>
        <div className="SeeMoreOnEndNext">
          {!this.state.lajmet.length < 1 ? (
            <button
              onClick={() => {
                this.loadMoreItems();
              }}
              class="buttonSeeMore"
            >
              Shiko Me Shume
            </button>
          ) : (
            "Nuk u gjeten lajme"
          )}
        </div>
      </div>
    );
  }
}

export default HomeNews;
